import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { ref, watchEffect } from 'vue';
import SvgLoader from '@/utils/SvgLoader.vue';
import { computed } from 'vue';

/**
 * ToastMessageのprops
 */
interface ToastMessageProps {
  message: string;
  type?: 'success' | 'error' | 'info' | 'warning';
  duration?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ToastMessage',
  props: {
    message: {},
    type: {},
    duration: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const visible = ref(true);

/**
 * ToastMessageのタイプ
 */
const close = () => {
  visible.value = false;
  emit('close');
};

watchEffect(() => {
  const timeout = setTimeout(() => {
    close();
  }, props.duration || 3000);

  return () => clearTimeout(timeout);
});

const svgIconName = computed(() => {
  switch (props.type) {
    case 'success':
      return 'toastSuccessIcon';
    case 'error':
      return 'toastErrorIcon';
    // successとerrorしか追加してないので必要に応じて追加してください
    default:
      return 'toastSuccessIcon';
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["toast-message", _ctx.type])
          }, [
            _createElementVNode("span", null, _toDisplayString(_ctx.message), 1),
            _createVNode(SvgLoader, {
              name: svgIconName.value,
              class: "close-button",
              onClick: close
            }, null, 8, ["name"])
          ], 2))
        : _createCommentVNode("", true)
    ], undefined, true),
    _: 1
  }))
}
}

})